export default "__VITE_ASSET__WVx18ads__"